import { assertValidVersion } from "@tsparticles/engine";
import { HexColorManager } from "./HexColorManager.js";
export async function loadHexColorPlugin(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addColorManager(new HexColorManager(), refresh);
}
